import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import _ from "lodash";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
export interface IListingToUpdate {
	CostUpdates: Array<{
		cost: number;
		listing_id: number;
	}>;
	CostLocked: boolean;
	PriceLocked?: boolean;
}
export const { thunk: updateListingCosts, slice: updateListingCostsSlice } = getThunkAndSlice<
	IListingToUpdate,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/UpdateListingCosts",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const costMap = new Map<number, number>();
		params.CostUpdates.forEach((param) => {
			costMap.set(param.listing_id, Number(param.cost));
		});
		const lockPatch = (isTarget: boolean) =>
			isTarget
				? {
						Cost_Locked: params.CostLocked,
						...(params.PriceLocked !== undefined ? { Price_Locked: params.PriceLocked } : {}),
					}
				: {};

		const newData = rootState.pricing.eventInventoryAll.data.map((event) => {
			const newItemCost = costMap.get(event.Listing_ID);
			return {
				...event,
				Item_Cost: !_.isNil(newItemCost) ? newItemCost : event.Item_Cost,
				...lockPatch(costMap.has(event.Listing_ID)),
			};
		});
		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId: getInventoryCacheEventId(rootState) }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				const newCost = costMap.get(item.Listing_ID);
				return {
					...item,
					Listing_Cost: !_.isNil(newCost) ? newCost : item.Listing_Cost,
					...lockPatch(costMap.has(item.Listing_ID)),
				};
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
